import { render, staticRenderFns } from "./IncidentApprovalStatusBadge.vue?vue&type=template&id=0af75a74&"
import script from "./IncidentApprovalStatusBadge.vue?vue&type=script&lang=js&"
export * from "./IncidentApprovalStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports